import { useMutation, useQueryClient } from '@tanstack/react-query';
import request from '@/services/api';

export const usePromocodeCreate = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (data: any) => {
      const res = await request.post('/promocode', data);
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['promocode-list'] });
    }
  });
};

export const usePromocodeUpdate = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, data }: { id: string, data: any }) => {
      const res = await request.patch(`/promocode/${id}`, data);
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['promocode-list'] });
    }
  });
};

export const usePromocodeDelete = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (id: string) => {
      const res = await request.delete(`/promocode/${id}`);
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['promocode-list'] });
    }
  });
};
